import React from 'react';
import { useHistory } from 'react-router-dom';
import './Footer.css';
import Logo from './bodex_crop.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../i18n/LanguageContext';

const Footer = ({ onShowCookieConsent }) => {
    const history = useHistory();
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const currentYear = new Date().getFullYear();
    const { t, language } = useLanguage();

    const supportEmail =
        language === 'no' ? 'support@bodex.no'
        : language === 'dk' ? 'support@bodex.dk'
        : 'support@bodex.se';

    const handleLogout = async () => {
        try {
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userEmail');
            history.push('/');
        } catch (error) {
            console.error("An error occurred while logging out:", error);
        }
    };

    // Navigation function
    const navigateTo = (path) => {
        history.push(path);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <div className="footer-colorful-line"></div>
            <div className="footer-wrapper">
                <footer className="footer">
                    <div className="footer-content">
                        <div className="footer-column logo-column">
                            <div className="footer-logo">
                                <img src={Logo} alt="Bodex Logo" />
                            </div>
                            <p className="company-description">
                                {t('footer.description')}
                            </p>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <i className="contact-icon">✉️</i>
                                    <a href={`mailto:${supportEmail}`} className="email-link">{supportEmail}</a>
                                </div>
                            </div>
                        </div>

                        <div className="footer-column links-column">
                            <h4>{t('footer.navigate')}</h4>
                            <ul className="footer-links">
                                <li onClick={() => navigateTo('/')}>{t('footer.start')}</li>
                                <li onClick={() => navigateTo('/object-form?workflow=direct')}>{t('common.createAd')}</li>
                                <li onClick={() => navigateTo('/faq')}>{t('common.faq')}</li>
                                {isLoggedIn && <li onClick={handleLogout}>{t('common.logout')}</li>}
                            </ul>
                        </div>

                        <div className="footer-column links-column">
                            <h4>{t('footer.information')}</h4>
                            <ul className="footer-links">
                                <li onClick={() => navigateTo('/privacy')}>{t('footer.privacy')}</li>
                                <li onClick={() => navigateTo('/terms')}>{t('footer.terms')}</li>
                                <li onClick={() => onShowCookieConsent && onShowCookieConsent()}>
                                    <FontAwesomeIcon icon={faCookieBite} className="cookie-icon" />
                                    <span>{t('footer.cookieSettings')}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </footer>
                <div className="sub-footer">
                    <p>Copyright &copy; {currentYear} Bodex </p>
                    <p>
                        {t('footer.acceptance')}
                        <span
                            className="link-text"
                            onClick={() => navigateTo('/terms')}
                        > {t('footer.terms')} </span>
                        {t('footer.and')}
                        <span
                            className="link-text"
                            onClick={() => navigateTo('/privacy')}
                        > {t('footer.privacy')}</span>
                    </p>
                </div>
            </div>
        </>
    );
};

export default Footer;
